module.exports = __webpack_public_path__ + "static/media/enhanced.59a2f66f.png";